<template>
  <span>
    <div v-for="(company, i) in companies" class="my-3">
      <v-card>
        <v-simple-table bordered>
          <thead>
            <tr>
              <th colspan="8" class="pa-3">
                <h2>
                  {{ company.name }}
                  <small class="mr-1">({{ company.id }})</small>
                </h2>
              </th>
            </tr>
            <tr></tr>
          </thead>
          <tbody>
            <template v-if="company.company_extensions.length === 0">
              <tr>
                <td colspan="8" class="text-center">هیچ افزونه ای خریداری نشده</td>
              </tr>
            </template>
            <template v-else>
              <tr>
                <th colspan="5">افزونه</th>
                <th>تاریخ خرید</th>
                <th>تاریخ انقضا</th>
                <th>آزمایشی</th>
              </tr>
              <tr v-for="extension in company.company_extensions">
                <td colspan="5" class="text-right">{{ extension.extension }}</td>
                <td>{{ extension.start_at }}</td>
                <td>{{ extension.expire_at }}</td>
                <td>{{ extension.is_trial ? 'بله' : 'خیر' }}</td>
              </tr>
            </template>
          </tbody>
        </v-simple-table>
      </v-card>
    </div>
  </span>
</template>

<script>
export default {
  props: {
    companies: {},
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  methods: {},
};
</script>
